/* @flow */
'use strict';
/* :: import type {Batch, Query, QueryResult, Callback} from './' */

var _regeneratorRuntime = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _classCallCheck = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/codebuild/output/src122629992/src/niftron-profile/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _require = require('./utils'),
    filter = _require.filter,
    sortAll = _require.sortAll,
    take = _require.take,
    map = _require.map;

var Key = require('./key'); // Errors


var Errors = require('./errors');

var MemoryDatastore = /*#__PURE__*/function () {
  /* :: data: {[key: string]: Buffer} */
  function MemoryDatastore() {
    _classCallCheck(this, MemoryDatastore);

    this.data = {};
  }

  _createClass(MemoryDatastore, [{
    key: "open",
    value: function () {
      var _open = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      function open() {
        return _open.apply(this, arguments);
      }

      return open;
    }()
  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(key
      /* : Key */
      , val
      /* : Buffer */
      ) {
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                this.data[key.toString()] = val;

              case 1:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function put(_x, _x2) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(key
      /* : Key */
      ) {
        var exists;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return this.has(key);

              case 2:
                exists = _context3.sent;

                if (exists) {
                  _context3.next = 5;
                  break;
                }

                throw Errors.notFoundError();

              case 5:
                return _context3.abrupt("return", this.data[key.toString()]);

              case 6:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function get(_x3) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
  }, {
    key: "has",
    value: function () {
      var _has = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(key
      /* : Key */
      ) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                return _context4.abrupt("return", this.data[key.toString()] !== undefined);

              case 1:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function has(_x4) {
        return _has.apply(this, arguments);
      }

      return has;
    }()
  }, {
    key: "delete",
    value: function () {
      var _delete2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(key
      /* : Key */
      ) {
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                delete this.data[key.toString()];

              case 1:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function _delete(_x5) {
        return _delete2.apply(this, arguments);
      }

      return _delete;
    }()
  }, {
    key: "batch",
    value: function batch()
    /* : Batch<Buffer> */
    {
      var _this = this;

      var puts = [];
      var dels = [];
      return {
        put: function put(key
        /* : Key */
        , value
        /* : Buffer */
        )
        /* : void */
        {
          puts.push([key, value]);
        },
        delete: function _delete(key
        /* : Key */
        )
        /* : void */
        {
          dels.push(key);
        },
        commit: function () {
          var _commit = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
            return _regeneratorRuntime.wrap(function _callee6$(_context6) {
              while (1) {
                switch (_context6.prev = _context6.next) {
                  case 0:
                    puts.forEach(function (v) {
                      _this.data[v[0].toString()] = v[1];
                    });
                    puts = [];
                    dels.forEach(function (key) {
                      delete _this.data[key.toString()];
                    });
                    dels = [];

                  case 4:
                  case "end":
                    return _context6.stop();
                }
              }
            }, _callee6);
          }));

          function commit() {
            return _commit.apply(this, arguments);
          }

          return commit;
        }()
      };
    }
  }, {
    key: "query",
    value: function query(q
    /* : Query<Buffer> */
    )
    /* : Iterator */
    {
      var it = Object.entries(this.data);
      it = map(it, function (entry) {
        return {
          key: new Key(entry[0]),
          value: entry[1]
        };
      });

      if (q.prefix != null) {
        it = filter(it, function (e) {
          return e.key.toString().startsWith(q.prefix);
        });
      }

      if (Array.isArray(q.filters)) {
        it = q.filters.reduce(function (it, f) {
          return filter(it, f);
        }, it);
      }

      if (Array.isArray(q.orders)) {
        it = q.orders.reduce(function (it, f) {
          return sortAll(it, f);
        }, it);
      }

      if (q.offset != null) {
        var i = 0;
        it = filter(it, function () {
          return i++ >= q.offset;
        });
      }

      if (q.limit != null) {
        it = take(it, q.limit);
      }

      if (q.keysOnly === true) {
        it = map(it, function (e) {
          return {
            key: e.key
          };
        });
      }

      return it;
    }
  }, {
    key: "close",
    value: function () {
      var _close = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      function close() {
        return _close.apply(this, arguments);
      }

      return close;
    }()
  }]);

  return MemoryDatastore;
}();

module.exports = MemoryDatastore;